import React, { Fragment } from "react";
import Page from "../../components/page";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { Async } from "react-select";
import Dialog from "../../components/dialog";

export default function() {
  
  const { history } = this.props;
  const {
    assignSuccess,
    machineId,
    courierNumber,
    showCourier,
    errMsg,
    showScanBtn,
    checkModelPop,
  } = this.state;
  return (
    <Page header="Send Machine">
      {assignSuccess && (
        <Dialog close={() => history.replace("/machine")}>
          <span className="dialog-span">
            Machine has been assigned to courier/branch
          </span>
          <button onClick={() => history.replace("/machine")}>Ok</button>
        </Dialog>
      )}
      <div className="button-group">
        <button
          className={showCourier ? "active" : ""}
          onClick={() => this.setState({ showCourier: true })}
        >
          Courier No.
        </button>
        <button
          className={!showCourier ? "active" : ""}
          onClick={() => this.setState({ showCourier: false })}
        >
          Branch
        </button>
      </div>
      
      {!showCourier && (
        <div>
          <Async
            placeholder="Select a branch"
            cacheOptions
            defaultOptions
            loadOptions={this._searchBranches}
            onChange={({ value, label }) => this.setState({ branchId: value })}
          />
        </div>
      )}

      {/* search for a store Label (common) */}
      {showCourier ? (<h5 className="send-machine-label">Select destination store for equipment *</h5>) 
                  : (<h5 className="send-machine-label">Select destination store for equipment if applicable</h5> )}

      {/* Store Search box */}
      <Async
        placeholder="Search for a store"
        loadOptions={this._searchStores}
        value={ this.state.storeId !== '' ? ( { value: this.state.storeId, label: this.state.storeName }) : ''}
        onChange={({ value, label, machine_model,request_list }) => this.setState({ storeId: value, storeName:label, machine_model: machine_model, request_list:request_list })}
      />

      {/* show allowable machine model for selected store */}
      {showCourier && (
        <Fragment>
          <h5 className="send-machine-label">Machine codes allowed</h5>
          <div className="mm_wrap">
            {(this.state.storeId !== '' && this.state.machine_model !== undefined && this.state.machine_model.length !== 0) && (
              this.state.machine_model.map((item, index) => this._renderMachineModel(item, index) )
            )}
          </div>
        </Fragment>
      ) }

      {/* show requests ( courier_number is already setup. just machine needs to be selected ) */}
      {showCourier && (
        <Fragment>
          <h5 className="send-machine-label">Machine Request</h5>
          <div className="request_wrap">
          {(this.state.storeId !== '' && this.state.request_list !== undefined && this.state.request_list.length !== 0) && (
              this.state.request_list.map((item, index) => item.type === 'Machine' ? this._renderRequestList(item, index) : '' )
            )}
          </div>
        </Fragment>
      ) }

      {showCourier && (
        <Fragment>
        <h5 className="send-machine-label">Outgoing Courier Number *</h5>
        <div className="manual-container">
          <input
            value={this.state.courierNumber}
            id="courier_1"
            placeholder="Enter or scan courier number"
            maxLength="100"
            onChange={event =>
              this.setState({
                courierNumber: event.target.value
              })
            }
          />
          {showScanBtn && (
          <NavLink
            to={`/scanner?url=${`/machine/${machineId}/send/courier`}`}
            className="scanner-button round"
          >
            <FontAwesomeIcon icon={faBarcode} size="2x" />
            <span>Scan</span>
          </NavLink>
          )}
        </div>
        </Fragment>
      )}

      {showCourier && (
        <Fragment>
        <h5 className="send-machine-label">Incoming Courier Number</h5>
        <div className="manual-container">
          <input
            value={this.state.courierNumber2}
            id="courier_2"
            placeholder="Enter or scan courier number"
            maxLength="100"
            onChange={event =>
              this.setState({
                courierNumber2: event.target.value
              })
            }
          />
          {showScanBtn && (
          <NavLink
            to={`/scanner?url=${`/machine/${machineId}/send/courier/${courierNumber}`}`}
            className="scanner-button round"
          >
            <FontAwesomeIcon icon={faBarcode} size="2x" />
            <span>Scan</span>
          </NavLink>
          )}
        </div>
        </Fragment>
      )}

      {/* cancel / submit */}
      <div className="button-group">
        <button onClick={() => this.props.history.replace("/machine")}>
          Cancel
        </button>
        <button onClick={this._sendMachine}>Confirm</button>
      </div>

      { checkModelPop && (
        <Dialog close={() => this.setState({ checkModelPop: false, checkModelPopMsg: "" })}>
          <span className="dialog-span" style={{ whiteSpace: 'pre-line'}}>{this.state.checkModelPopMsg}</span>
          <div style={{paddingTop: 10, textAlign: 'center'}}>
            <button style={{marginRight: 10}} onClick={() => {
              this.setState({ checkModelPop: false, checkModelContinue : false, })
              }}>Cancel</button>
            <button onClick={() => {
              this.setState({ checkModelPop: false, checkModelContinue : true }, ()=>{
                this._sendMachine()
              })
              }}>Continue</button>
          </div>
        </Dialog>
      )}

      {errMsg && (
        <div>
          <h3 className="machine-errMsg">{errMsg}</h3>
        </div>
      )}
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/screens/send/view.js